<template>
    <div id="contentcontainter" class="standard-mode" style="max-width: 1920px" role="main" aria-labelledby="onboarding-page-title">
        <!-- SR-H1 für Seitenkontext -->
        <h1 id="onboarding-page-title" class="sr-only">Onboarding mit Quaro</h1>

        <v-row>
            <v-col class="col-xl-8 col-md-8 col-sm-12 mx-auto">
                <v-row>
                    <v-col>
                        <v-card class="rounded_card quaroshadow" role="region" aria-labelledby="onboarding-video-title" aria-describedby="onboarding-video-help">
                            <div class="backsheet"></div>
                            <v-card-title>
                                <!-- Echte semantische Überschrift -->
                                <h2 id="onboarding-video-title" class="mb-0" style="font-size: 1.5rem; font-weight: 300">Onboarding-Video</h2>
                            </v-card-title>
                            <v-card-subtitle id="onboarding-video-subtitle">Keyword-Research with Quaro</v-card-subtitle>

                            <!-- SR-Hilfe mit Kurzbeschreibung/Nutzhinweis -->
                            <p id="onboarding-video-help" class="sr-only">Embedded YouTube video with captions enabled. Use keyboard controls to play, pause, and adjust volume.</p>

                            <v-card-text>
                                <div class="video-block">
                                    <iframe
                                        src="https://www.youtube.com/embed/UI7JQO39fSE?cc_load_policy=1&hl=en&cc_lang_pref=en"
                                        title="Keyword-Recherche mit Quaro – Demo-Video"
                                        loading="lazy"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                        aria-describedby="onboarding-video-subtitle onboarding-video-help"></iframe>
                                </div>
                                <!-- Fallback-Link (falls Iframe blockiert) -->
                                <p class="sr-only">
                                    If the video does not load, open it directly:
                                    <a href="https://www.youtube.com/watch?v=UI7JQO39fSE">YouTube: Keyword-Recherche mit Quaro</a>.
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>

            <v-col class="col-xl-4 col-md-4 col-sm-12 pa-6">
                <v-card class="rounded_card quaroshadow" role="region" aria-labelledby="onboarding-scheduler-title" aria-describedby="onboarding-scheduler-help">
                    <div class="backsheet"></div>

                    <v-card-title>
                        <h2 id="onboarding-scheduler-title" class="mb-0" style="font-size: 1.5rem; font-weight: 300">Onboarding-Book an Appointment</h2>
                    </v-card-title>

                    <!-- SR-Hilfe -->
                    <p id="onboarding-scheduler-help" class="sr-only">Embedded scheduling widget. After the frame loads, select a date and time to book your onboarding call.</p>

                    <v-card-text>
                        <!-- Calendly inline widget begin -->
                        <div
                            class="calendly-inline-widget"
                            data-url="https://calendly.com/quaro-meeting/onboarding?embed_domain=quaro.io&embed_type=Inline&hide_gdpr_banner=1&primary_color=009f87"
                            style="height: 850px"
                            role="group"
                            aria-label="Calendly scheduling widget"
                            aria-describedby="onboarding-scheduler-help"></div>
                        <!-- Calendly inline widget end -->

                        <!-- Fallback-Link für Screenreader/NoScript -->
                        <p class="sr-only">
                            If the scheduler does not load, use this link:
                            <a href="https://calendly.com/quaro-meeting/onboarding">Open Calendly onboarding scheduling</a>.
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import DemoVideo from "../components/knowledgebase/DemoVideo.vue"
    import LatestUpdates from "../components/knowledgebase/LatestUpdates.vue"
    import Clustering from "../components/knowledgebase/Clustering.vue"
    // import uuid from "uuid/v4"

    export default {
        components: {
            DemoVideo,
            LatestUpdates,
            Clustering
        },
        data() {
            return {
                model: 1,
                selected: null,
                doc_items: [
                    {
                        title: "User Interface",
                        active: false,
                        items: [
                            { title: "1. Collections", active: false, component: "DemoVideo" },
                            { title: "2. Keyword Table", active: false, component: "LatestUpdates" },
                            { title: "3. Metriken", active: false, component: "LatestUpdates" }
                        ]
                    },
                    { title: "Create a research", active: false, component: "DemoVideo" },
                    { title: "Ideas vs. Suggests", active: false, component: "" },
                    { title: "Question Tool", active: false, component: "" },
                    { title: "Categorization & Clustering", active: false, component: "Clustering" },
                    {
                        title: "Advanced Filter",
                        active: false,
                        items: [
                            { title: "1. Basic filter", active: false, component: "DemoVideo" },
                            { title: "2. Advanced filter", active: false, component: "DemoVideo" }
                        ],
                        component: ""
                    },
                    { title: "SERP Preview", active: false, component: "" },
                    { title: "Sharing", active: false, component: "" },
                    { title: "Import & Export", active: false, component: "" }
                ]
                // id: uuid(),
                // widget: undefined,
                // config: {
                //     selector: ".changelog",
                //     account: "xb9Ppy",
                //     callbacks: {
                //         onWidgetReady: (widget) => {
                //             this.widget = widget
                //         }
                //         // onShowWidget: () => this.$parent.$emit("close:header-items", [this.id])
                //     }
                // }
            }
        },
        computed: {
            activeC() {
                return
            }
        },
        methods: {
            getSelected() {
                // this.model is an index - we have to unwind all childs to extract the selected item
                console.log(this.model)

                let all = this.doc_items.map((item, index) => {
                    let obj = {}
                    obj.component = item.component
                    obj.title = item.title
                    return obj
                })

                let hasChilds = JSON.parse(JSON.stringify(this.doc_items.filter((item) => item.items)))
                hasChilds.map((item) => {
                    item.items.map((child, index) => {
                        let obj = {}
                        obj.component = child.component
                        obj.title = child.title
                        all.push(obj)
                    })
                })
                if (all[this.model].component) {
                    this.selected = all[this.model]
                }
                console.log(all)

                return
            }
        },
        mounted() {
            this.getSelected()
            const recaptchaScript = document.createElement("script")
            recaptchaScript.setAttribute("src", "https://assets.calendly.com/assets/external/widget.js")
            document.head.appendChild(recaptchaScript)

            // //Inject Headway app script
            // let headway = document.getElementById("headway-script")
            // if (headway) return //Script already appended

            // //Create promise which resolves on script load
            // let promise = new Promise((resolve, reject) => {
            //     let script = document.createElement("script")
            //     script.src = "//cdn.headwayapp.co/widget.js"
            //     script.id = "headway-script"
            //     script.setAttribute("async", true)
            //     document.head.appendChild(script)
            //     script.onload = resolve //Resolve when loaded
            //     script.onerror = reject
            // })
            // await promise //Await for the script to be resolved

            // //Init the widget now that the script has loaded
            // // eslint-disable-next-line no-undef
            // const waitForHeadway = () => {
            //     if (window["Headway"]) {
            //         window.Headway.init(this.config)
            //     } else {
            //         setTimeout(() => waitForHeadway(), 100)
            //     }
            // }
            // waitForHeadway()
            // console.log("loading finished")
        }
    }
</script>

<style>
    .video-block {
        width: 100%;
    }
    .fa-chevron-down {
        font-size: 5px;
    }
    .v-list-item__icon.v-list-group__header__append-icon > i {
        font-size: 12px;
    }
</style>
